module.exports = __webpack_public_path__ + "img/bike.f89b3763.png";